module.exports = __webpack_public_path__ + "static/assets/e87650f1dc477d708bd4a839c7bde4a8.svg";